import { useFeatureFlag } from '../../../../../services/feature-flag';

// Em produção o JSON inviteGuest do Remote Config substitui o default inteiro:
// propriedade ausente precisa significar fechado
const useGeneratorEnabled = () => {
  const { flags, loading } = useFeatureFlag();

  return {
    enabled: flags?.inviteGuest?.personalizedInviteGenerator?.enabled === true,
    loading,
  };
};

export default useGeneratorEnabled;
